import { useMemo } from 'react'

import { createConnectorRegistry, platformConnectors } from '@krp/platform-ui'

import { useAppSelector } from '../../app/hooks'

const selectConnectors = platformConnectors.select()

/**
 * Виды ресурсов с манифестами (права и модули) с сервера (ADR-22): подписка и результат из общего кэша. Форма «Добавить
 * источник», права формы, карточка и консоль прав строятся из них, а не из списков, вписанных в клиент. `refetch` — для
 * кнопки «Повторить», когда список не пришёл.
 */
export function useConnectors() {
  const subscription = platformConnectors.useQuerySubscription()
  const query = useAppSelector(selectConnectors)
  const registry = useMemo(() => createConnectorRegistry(query.data ?? []), [query.data])
  return { query, registry, refetch: subscription.refetch }
}
